import React from 'react';
import BrandLoader from 'shared/components/ui/BrandLoader';

/** Kept so every call site stays as it is; `message` is the loader's label. */
const BrandLoadingSpinner = ({ message = 'Loading', size = 'medium' }) => {
  const s = typeof size === 'number' ? (size < 48 ? 'sm' : 'md') : ({ small: 'md', medium: 'md', large: 'lg' }[size] || 'md');
  return (
    <div className="flex items-center justify-center p-8">
      <BrandLoader size={s} label={message} />
    </div>
  );
};

export default BrandLoadingSpinner;
